import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Bolt = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M23.2096 3.1602C23.6734 3.46003 23.8063 4.07909 23.5065 4.5429L13.8372 19.5H28C28.3663 19.5 28.7032 19.7002 28.8783 20.0219C29.0534 20.3436 29.0386 20.7353 28.8398 21.0429L18.1731 37.5429C17.8733 38.0067 17.2542 38.1396 16.7904 37.8398C16.3266 37.54 16.1937 36.9209 16.4935 36.4571L26.1628 21.5H12C11.6337 21.5 11.2968 21.2998 11.1217 20.9781C10.9466 20.6564 10.9614 20.2647 11.1602 19.9571L21.8269 3.4571C22.1267 2.99329 22.7458 2.86036 23.2096 3.1602Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Bolt;
